module.exports = __webpack_public_path__ + "img/sync.38af0dcb.svg";